module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "bc-menu-link__icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [(_vm.name === 'home') ? [_c('path', {
    attrs: {
      "d": "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }
  })] : (_vm.name === 'bell') ? [_c('path', {
    attrs: {
      "d": "M10.268 21a2 2 0 0 0 3.464 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
    }
  })] : (_vm.name === 'users') ? [_c('path', {
    attrs: {
      "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })] : (_vm.name === 'ticket') ? [_c('path', {
    attrs: {
      "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13 5v2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13 17v2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13 11v2"
    }
  })] : (_vm.name === 'calendar') ? [_c('path', {
    attrs: {
      "d": "M8 2v4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "18",
      "height": "18",
      "x": "3",
      "y": "4",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 10h18"
    }
  })] : (_vm.name === 'info') ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 16v-4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 8h.01"
    }
  })] : (_vm.name === 'building') ? [_c('rect', {
    attrs: {
      "width": "16",
      "height": "20",
      "x": "4",
      "y": "2",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 22v-4h6v4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 10h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 14h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 10h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 14h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 10h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 14h.01"
    }
  })] : (_vm.name === 'image') ? [_c('rect', {
    attrs: {
      "width": "18",
      "height": "18",
      "x": "3",
      "y": "3",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "9",
      "r": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
    }
  })] : _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bdb42d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/BcMenuLinkIcon.vue
// module id = 1469
// module chunks = 0